import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import { STORAGE_KEYS } from '../config/app.config';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'ar', label: 'العربية' },
  { code: 'es', label: 'Español' },
  { code: 'it', label: 'Italiano' },
  { code: 'de', label: 'Deutsch' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'zh', label: '中文' },
  { code: 'ru', label: 'Русский' },
];

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleChange = (code) => {
    i18n.changeLanguage(code);
    try {
      localStorage.setItem(STORAGE_KEYS.LANGUAGE, code);
    } catch (_) {}
    handleClose();
  };

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <>
      <IconButton
        onClick={handleOpen}
        aria-label="language"
        sx={{
          color: 'inherit',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 180,
            boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
            borderRadius: 2,
          },
        }}
      >
        {LANGUAGES.map((lang) => {
          const isSelected = i18n.language === lang.code;
          return (
            <MenuItem
              key={lang.code}
              onClick={() => handleChange(lang.code)}
              selected={isSelected}
              sx={{
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-selected': {
                  backgroundColor: `${theme.palette.primary.main}15`,
                  '&:hover': {
                    backgroundColor: `${theme.palette.primary.main}25`,
                  },
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                {isSelected && <CheckIcon fontSize="small" color="primary" />}
              </ListItemIcon>
              <ListItemText
                primary={lang.label}
                primaryTypographyProps={{
                  fontWeight: isSelected ? 600 : 400,
                }}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
